// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import LockIcon from "@mui/icons-material/Lock";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const DoorDetailsContainer = styled.div`
  height: 762px;
  width: 640px;
  border-radius: 20px;
  background-color: ${COLORS.primaryWhite};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  outline: none;
  padding: 50px;
  padding-right: 28px;
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  width: 100%;
`;

export const UsersList = styled.div`
  height: 380px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: scroll;
  padding-right: 28px;
  margin-right: 28px;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 28px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.rainbowIndigo} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 47.8px;
  width: 100%;
  align-items: center;
  border-bottom: 3px solid #EAE8E8;
  cursor: pointer;
  
`;

export const CheckBox = styled.div(
  ({ isSelected }) => css`
  width: 16px;
  height: 16px;
  margin-right: 20px;
  border-radius: 50px;
  border: 1px solid ${COLORS.rainbowIndigo};
  background-color: ${isSelected ? COLORS.rainbowIndigo : "transparent"};
  `);

export const UserIcon = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 12px;
  border-radius: 50px;
  background-color: ${COLORS.secondaryGray}
`;

export const UserName = styled.div`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.rainbowIndigo};
  font-weight: 600;
  height: 48px;
  display: flex;
  align-items: center;
  `;

export const InputAtomContainer = styled.div(
  ({ width }) => css`
    width: 100%;
    padding-right: 28px;
  `
);

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;
export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div(
  ({ color }) => css`
    font-size: 30px;
    font-family: ${FONTS.newsharp};
    color: ${color ? color : COLORS.cornflowerBlue};
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
  `
);

export const TitleContainer = styled.div(
  ({ color }) => css`
    display: flex;
    flex-direction: row;
    color: ${color ? color : COLORS.cornflowerBlue};
  `
);

export const LockerIcon = styled(LockIcon)(
  ({ color }) => css`
    && {
      margin-right: 10px;
      color: ${color ? color : COLORS.cornflowerBlue};
    }
    &.MuiSvgIcon-root {
      height: 33px;
    }
  `
);

export const Status = styled.text(
  ({ color }) => css`
    font-size: 22px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.rainbowIndigo};
    font-weight: 600;
  `
);

export const EquipmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 26px;
`;

export const Subtitle = styled.text`
  font-size: 20px;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
`;

export const EquipmentContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 25px;
`;

export const EquipmentDescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const EquipmentName = styled.text`
  font-size: 16px;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
  margin-right: 20px;
`;

export const EquipmentStatus = styled.text(
  ({ color }) => css`
    font-size: 14px;
    font-family: ${FONTS.montserrat};
    color: ${color ? color : COLORS.primaryGreen};
    font-weight: 600;
  `
);

export const Bar = styled.div`
  height: 2px;
  background-color: ${COLORS.backgroundColor};
  margin: 10px 0;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ButtonContainer = styled.div`
  margin: 0 auto;
  margin-top: 20px;
`;

export const ActionIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 40px;
  cursor: pointer;
`;
